
    import { defineComponent } from 'vue';
    import { getVersionApp } from '../services/versions.helpers';

    export default defineComponent({
        setup() {
            const version = getVersionApp();
            
            return {
                version
            }
        }
    })
